import { defineStore } from 'pinia';
import type { UserInfo, LoginContextInfo, UserProps, WxUserInfo, StaffInfo } from '@shared/types';

interface UserState {
  userInfo: UserInfo; // 当前登录用户信息
  viewStaffInfo: StaffInfo; // 当前视图经理信息
}

// 用户信息
export const useUserStore = defineStore({
  id: 'user',
  state: (): UserState => {
    return {
      // 当前登录用户信息，不区分运行环境、用户身份、视图等
      // 注意初始化时仅设置了必填字段的默认值，全部字段请参考类型定义
      userInfo: {
        openId: '',
        external_userid: '',
        unionId: '',
        visitorId: '',
        mainId: '',
        distinctId: '',
        identity: '',
      },
      // 当前视图经理信息
      // 注意初始化时仅设置了必填字段的默认值，全部字段请参考类型定义
      viewStaffInfo: {
        userId: '',
        staffId: '',
        name: '',
        avatar: '',
        qrCode: '',
      },
    };
  },
  getters: {},
  actions: {
    /**
     * 更新登录用户上下文信息
     * @param data {LoginContextInfo} 登录用户上下文信息
     */
    async setLoginContextInfo({
      openId = '',
      unionId = '',
      external_userid = '',
      visitorId = '',
      mainId = '',
      staffId = '',
      userId = '',
      userName = '',
      staffName = '',
      alias = '',
      visitorImg = '',
      isYetAuth,
      hideConsumerFun,
      closeContact,
      closeConsumerTag,
      closeGroupShare,
      lotteryPrivilege,
    }: LoginContextInfo) {
      this.userInfo = {
        ...this.userInfo,
        openId,
        unionId,
        external_userid,
        visitorId,
        mainId,
        staffId,
        userId,
        staffName,
        userName,
        alias,
        visitorImg,
        isYetAuth,
        hideConsumerFun,
        closeContact,
        closeConsumerTag,
        closeGroupShare,
        lotteryPrivilege,
      };
    },

    /**
     * 更新用户公共属性
     * @param data {UserProps} 用户公共属性
     */
    async setUserProps({ isLogin = true, customerType = '', distinctId = '', identity = '' }: UserProps) {
      this.userInfo = {
        ...this.userInfo,
        isLogin,
        customerType,
        distinctId,
        identity,
      };
    },

    /**
     * 更新微信用户信息
     * @param data {WxUserInfo} 微信用户信息
     */
    async setWxUserInfo({
      id = '',
      openId = '',
      unionId = '',
      nickName = '',
      pinyin = '',
      mobile = '',
      phoneNumber = '',
      countryCode = '',
      gender = 0,
      avatar = '',
      city = '',
    }: WxUserInfo) {
      // 不再更新 openId、unionId
      this.userInfo = {
        ...this.userInfo,
        id,
        nickName,
        pinyin,
        mobile,
        phoneNumber,
        countryCode,
        gender,
        avatar,
        city,
      };
    },

    /**
     * 更新当前视图经理信息
     * @param data {StaffInfo} 经理信息
     */
    async setViewStaffInfo(data: StaffInfo) {
      this.viewStaffInfo = {
        ...this.viewStaffInfo,
        ...data,
      };
    },
  },
});
